module.exports = __webpack_public_path__ + "static/img/72010B_3_R_20200730_fit.cc4637c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/72010B_3_R_20200730_fit.png
// module id = YGoH
// module chunks = 0